<!-- div -->
<div class="ui-g">
  <!-- div -->
  <div class="ui-g-12">
    <p-tabView #tabviewMain>
      <p-tabPanel header="Debug customer job prices">
        <!-- div -->
        <div class="card card-w-title">
          <div class="ui-g-1"><label for="orderNumber">Order Id/Number</label></div>
          <div class="ui-g-2">
            <input pInputText [(ngModel)]="orderNumber" id="orderNumber" maxlength="50" />
          </div>
        </div>
        <!-- button -->
        <button pButton icon="fa ui-icon-check" (click)="getPrice($event)" label="Get Log"></button>

        <p-table
          [value]="pricelog"
          [lazy]="false"
          [paginator]="false"
          rowHover="false"
          resizableColumns="true"
          [class.no-zebra-shading]="true"
        >
          <ng-template pTemplate="header">
            <tr>
              <th>Log</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-item>
            <tr>
              <td>{{ item }}</td>
            </tr>
          </ng-template>
        </p-table>

        <!--- DATATABLE DEPRECATED ----
                <p-dataTabl [value]="pricelog" [lazy]="false" [sortable]="false" [paginator]="false" rowHover="false" resizableColumns="true"
                             [class.no-zebra-shading]="true">
                    <p-column field="" header="Log" [editable]="false" [style]="{'width':'180px'}">
                        <ng-template let-col let-data="rowData" let-ri="rowIndex" pTemplate="body">
                            <span>{{data}}</span>
                        </ng-template>
                    </p-column>
                </p-dataTable>
                ----->
      </p-tabPanel>
      <p-tabPanel header="Debug supplier job prices">
        <!-- div -->
        <div class="card card-w-title">
          <div class="ui-g-1"><label for="sjorderNumber">Order Id/Number</label></div>
          <div class="ui-g-2">
            <input pInputText [(ngModel)]="sjorderNumber" id="sjorderNumber" />
          </div>
        </div>
        <!-- button -->
        <button
          pButton
          icon="fa ui-icon-check"
          (click)="getSPrice($event)"
          label="Get Log"
        ></button>

        <p-table
          [value]="pricelog_s"
          [lazy]="false"
          [paginator]="false"
          rowHover="false"
          resizableColumns="true"
          [class.no-zebra-shading]="true"
        >
          <ng-template pTemplate="header">
            <tr>
              <th>Log</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-item>
            <tr>
              <td>{{ item }}</td>
            </tr>
          </ng-template>
        </p-table>

        <!--- DATATABLE DEPRECATED ----
                <p-dataTabl [value]="pricelog_s" [lazy]="false" [sortable]="false" [paginator]="false" rowHover="false" resizableColumns="true"
                             [class.no-zebra-shading]="true">
                    <p-column field="" header="Log" [editable]="false" [style]="{'width':'180px'}">
                        <ng-template let-col let-data="rowData" let-ri="rowIndex" pTemplate="body">
                            <span>{{data}}</span>
                        </ng-template>
                    </p-column>
                </p-dataTable>
                ----->
      </p-tabPanel>

      <p-tabPanel header="Debug on Hold Matching">
        <div class="card card-w-title">
          <div class="ui-g-1"><label for="ohjobnumber">Job Id/Number</label></div>
          <div class="ui-g-2"><input pInputText [(ngModel)]="ohjobnumber" id="ohjobnumber" /></div>
        </div>
        <button
          pButton
          icon="fa ui-icon-check"
          (click)="getOHMatching($event)"
          label="Get Log"
        ></button>

        <p-table
          [value]="pricelog_h"
          [lazy]="false"
          [paginator]="false"
          rowHover="false"
          resizableColumns="true"
          [class.no-zebra-shading]="true"
        >
          <ng-template pTemplate="header">
            <tr>
              <th>Log</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-data>
            <tr>
              <td>{{ data }}</td>
            </tr>
          </ng-template>
        </p-table>

        <!-- DATATABLE DEPRECATED ----
                <p-dataTabl [value]="pricelog_h" [lazy]="false" [sortable]="false" [paginator]="false" rowHover="false" resizableColumns="true"
                             [class.no-zebra-shading]="true">
                    <p-column field="" header="Log" [editable]="false" [style]="{'width':'180px'}">
                        <ng-template let-col let-data="rowData" let-ri="rowIndex" pTemplate="body">
                            <span>{{data}}</span>
                        </ng-template>
                    </p-column>
                </p-dataTable>
                ----->
      </p-tabPanel>
      <p-tabPanel header="Debug EC Matching">
        <div class="card card-w-title">
          <div class="ui-g-1"><label for="ecjobnumber">Job Id/Number</label></div>
          <div class="ui-g-2"><input pInputText [(ngModel)]="ecjobnumber" id="ecjobnumber" /></div>
        </div>
        <button
          pButton
          icon="fa ui-icon-check"
          (click)="getECMatching($event)"
          label="Get Log"
        ></button>

        <p-table
          [value]="pricelog_e"
          [lazy]="false"
          [paginator]="false"
          rowHover="false"
          resizableColumns="true"
          [class.no-zebra-shading]="true"
        >
          <ng-template pTemplate="header">
            <tr>
              <th>Log</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-data>
            <tr>
              <td>
                <span>{{ data }}</span>
              </td>
            </tr>
          </ng-template>
        </p-table>

        <!--- DATATABLE DEPRECATED ----
                <p-dataTabl [value]="pricelog_e" [lazy]="false" [sortable]="false" [paginator]="false" rowHover="false" resizableColumns="true"
                             [class.no-zebra-shading]="true">
                    <p-column field="" header="Log" [editable]="false" [style]="{'width':'180px'}">
                        <ng-template let-col let-data="rowData" let-ri="rowIndex" pTemplate="body">
                            <span>{{data}}</span>
                        </ng-template>
                    </p-column>
                </p-dataTable>
                ------>
      </p-tabPanel>
    </p-tabView>
  </div>
</div>

<!-- loading template -->
<ng-template #loading>Loading...</ng-template>
